import { useTranslation } from 'react-i18next';

import type { Invoice } from '~/api/invoices/types';

import { useClientsWithTrashed } from '~/api/clients';
import { AlertDialog, Button } from '~/components';

type Props = {
  invoice: Invoice;
  loading?: boolean;
  onConfirm: () => void;
};

export const ConfirmResendCoInvoiceDialog = ({ invoice, loading, onConfirm }: Props) => {
  const { t } = useTranslation(['common', 'invoices']);
  const { data: clients } = useClientsWithTrashed();

  const client = clients.find(({ id }) => id === invoice.clientId);
  const contact = client?.contacts.find(({ id }) => id === invoice.contactId);
  const selfClientContact = contact?.emails.find(({ messages, type }) => messages.includes('invoices & credit notes') && type === 'user');

  return (
    <AlertDialog.Body status="danger">
      <AlertDialog.Title>{t('invoices:details.confirmResendCoInvoiceModal.title')}</AlertDialog.Title>

      <AlertDialog.Description>
        {selfClientContact
          ? t('invoices:details.confirmResendCoInvoiceModal.descriptionSendFromFreelancer')
          : t('invoices:details.confirmResendCoInvoiceModal.descriptionSendFromCreativeShelter')}
      </AlertDialog.Description>

      <AlertDialog.Actions>
        <Button emphasis="status" icon="Send" loading={loading} onClick={onConfirm}>
          {t('invoices:details.confirmResendCoInvoiceModal.confirm')}
        </Button>
      </AlertDialog.Actions>
    </AlertDialog.Body>
  );
};
